import React, { useState, useEffect, useRef } from 'react';
import './ActiveUsers.css';
import { io } from 'socket.io-client';

const ActiveUsers = () => {
  const [activeCount, setActiveCount] = useState(0);
  const [activeUsersList, setActiveUsersList] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const socketRef = useRef(null);
  const isExpandedRef = useRef(false);
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  // Keep ref in sync with state
  useEffect(() => {
    isExpandedRef.current = isExpanded;
  }, [isExpanded]);

  // Set up socket connection once
  useEffect(() => {
    socketRef.current = io(API_URL);

    // Listen for active user count updates (always update count)
    socketRef.current.on('active:users:update', (data) => {
      setActiveCount(data.count || 0);
      // Only update list if expanded AND users are provided
      // Use ref to get current value, not closure value
      if (isExpandedRef.current && data.users && Array.isArray(data.users) && data.users.length > 0) {
        setActiveUsersList(data.users);
      }
    });

    // Listen for active user list (only when explicitly requested)
    socketRef.current.on('active:users:list', (data) => {
      if (data.users) {
        setActiveUsersList(data.users);
      }
    });

    // Request initial count
    socketRef.current.emit('active:users:request');

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [API_URL]); // Only depend on API_URL, not isExpanded

  // Request user list when expanded
  useEffect(() => {
    if (isExpanded && socketRef.current) {
      // Request fresh list when expanding
      socketRef.current.emit('active:users:list:request');
    } else if (!isExpanded) {
      // Clear list when collapsed to prevent stale data
      setActiveUsersList([]);
    }
  }, [isExpanded]);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="active-users-container">
      <div 
        className="active-users win98-bevel-inset" 
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
        title="Click to view online users"
      >
        <span className="users-icon">👥</span>
        <span className="users-label">Active:</span>
        <span className="users-count">{activeCount}</span>
      </div>
      
      {isExpanded && (
        <div className="active-users-list win98-bevel-inset">
          <div className="users-list-header">
            <strong>Users Online ({activeCount})</strong>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                setIsExpanded(false);
              }}
              className="win98-button"
              style={{ fontSize: '0.8rem', padding: '2px 6px' }}
            >
              ✕
            </button>
          </div>
          <div className="users-list-content">
            {activeUsersList.length === 0 ? (
              <div className="users-list-empty">Loading users...</div>
            ) : (
              activeUsersList
                .filter(user => user && user.username && user.username.trim() !== '')
                .map((user, index) => (
                  <div key={user.userId || `user-${index}`} className="users-list-item">
                    <span className="user-status-dot" style={{
                      display: 'inline-block',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: '#4caf50',
                      marginRight: '6px',
                      verticalAlign: 'middle',
                      boxShadow: '0 0 4px #4caf50'
                    }} />
                    {user.username}
                  </div>
                ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActiveUsers;

